<template>
  <div>
    <detail :id="id" />
    <div>
      <el-button @click="closeAndBack">
        返回
      </el-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import Detail from './components/detail.vue';
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import { useTabsStore } from '../../../../../main';

const { closeAndBack } = useTabsStore();

const route = useRoute();

defineOptions({ name: 'BrokerLaborTaskDetail' }); // 任务详情

const id = computed(() => route.query && route.query.id ? String(route.query.id) : undefined);

</script>

<style lang="scss" scoped>

</style>
